import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { ControlMessageCategory } from '@/types/category';

import { PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY } from '@/hooks/api/use-category-queries';
import httpClient from '@/lib/axios-instance';
import { API_ROUTES } from '@/lib/routes/api-routes';

async function editCategory(payload: { id: number; name: string }) {
  const { id, name } = payload;
  const { data } = await httpClient.patch<ControlMessageCategory>(
    API_ROUTES.predefinedMessageCategories.detail(id),
    { name }
  );

  return data;
}

export function useEditCategoryMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: editCategory,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: PREDEFINED_MESSAGE_CATEGORIES_QUERY_KEY });
    },
  });
}
